export default "__VITE_ASSET__$_dZmggs__"